import styled from "styled-components";

export const Season = styled.p`
  font-size: ${({ theme }) => theme.old.fonts.size.normal};
  font-weight: ${({ theme }) => theme.old.fonts.weight.medium};
  line-height: 20px;
  color: ${({ theme }) => theme.old.colors.white};
`

export const Episodes = styled.span`
  color: ${({ theme }) => theme.old.colors.gray[525]};
`
